export default __webpack_public_path__ + "static/media/Yggdrasil.ea561aa0.png";